import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { formatPhoneNumber, isPlural } from '../util/Helper';
import { Grid, Row, Col } from 'react-bootstrap';
import ImageGrid from './ImageGrid';
import _ from 'lodash';
import moment from 'moment';

const ListItemDetails = (props) => {
  const [detailedData, setDetailedData] = useState([]);
  const [photos,setPhotos] = useState([]);
  useEffect(() => {
    const getHousing = async () => {
      const { data } = await axios.post(
        process.env.REACT_APP_API_GRAPHQL,
        {
          query: `
                  {listingById (listingId:"${props.listingId}")
                    {
                      listingId,
                      title, 
                      description, 
                      securityDeposit,
                      rent,
                      unitTypeTitle,
                      listingAddress,
                      listingCity,
                      listingZipCode,
                      roomsForRent,
                      bedroomCount,
                      dateAvailable,
                      lengthOfLease,
                      leaseEndDate,
                      leaseTypeTitle,
                      contactName,
                      contactEmail,
                      contactPhone,
                      utilities,
                      amenities,
                      roommateAttributes,
                      locationGroupTitle,
                      photos {title, imageUrl}
                    }
                  }`,
        }
      );
      setDetailedData(data.data.listingById);
    };
    getHousing();
  }, [props.listingId]);

  useEffect(() => {
      if(detailedData.photos) {
            let imagesList = detailedData.photos.map((val,i)=>{

                return({
                    src: process.env.REACT_APP_IMAGE_BASE + val.imageUrl,
                    width: 100,
                    height: 100,
                    title: val.title,
                    alt: val.title,
                    key: val.photoId,
                    id: val.photoId,
                    sizes: '(min-width: 480px) 50vw, (min-width: 1024px) 33.3vw, 100vw',
                });
            });
            imagesList.map(o => {
              return (async () => {
                const img = new Image();
                img.src = o.src;
                await img.decode();
                o.width = img.width;
                o.height = img.height;
                return(o);
              })();
            });
            imagesList = _.sortBy(imagesList, 'sortorder' );
            setPhotos(imagesList);
    }
  }, [detailedData.photos]); 

  const ImageSrc = () => { 
    if (photos && photos.length) {
      return (<ImageGrid photos={photos}  />); 
    } else {
      /*return (<img src='no-picture-available-icon-1.jpg' class='cardDetailsImg' alt={props.title ? 'Image of property at ' +  props.title : 'No picture available'} />); */
      return <></>
    }
  }

  const printArray = (dataArray) => {
    if (dataArray) {
      return dataArray.map((item, index) => (
        <p className='dataParagraph' key={index}>
          {item}
        </p>
      ));
    }
  };

  return (<div class="container-fluid">
    <div id='container' style={{ margin: `25px 25px 25px 25px` }}>
      {/*<ImageSrc />*/}
      <h2>{(detailedData.locationGrouptitle) ? <>{detailedData.locationGroupTitle} <br /></> : ''} {detailedData.listingAddress}, {detailedData.listingCity}</h2>
      <p className='meta'>
        {' '}
        {detailedData.unitTypeTitle} | ${detailedData.rent} |{' '}
        {detailedData.leaseTypeTitle
          ? detailedData.leaseTypeTitle + ' lease | '
          : ''}
        {detailedData.bedroomCount} bedroom{isPlural(detailedData.bedroomCount)}
      </p>
      <p className='lead'>{detailedData.title}</p>
      {/*<address>
        <b class='cardDetailsInfoBold'>
          <FontAwesomeIcon icon={faPhone} />{' '}
          {formatPhoneNumber(detailedData.contactPhone)}
        </b>
      </address>*/}
      <h3>Contact</h3>
      <address><strong>
      {detailedData.contactName}{' '}</strong><br />
       <FontAwesomeIcon icon={faPhone} />{' '}
       {formatPhoneNumber(detailedData.contactPhone)}{' '}<br />
            <a
              class='contactEmail'
              href={`mailto:${detailedData.contactEmail}?subject=MNSU Off-Campus Housing`}
            >
              <FontAwesomeIcon icon={faEnvelope} /> {detailedData.contactEmail}
            </a>
      </address>
      <h3>Details</h3>
      {<p>{detailedData.description}</p>}
    </div>
    <div className="section-wrap section-grey">
     <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="box">
            <h3>Amenities</h3>
            {(detailedData.amenities && detailedData.amenities.length > 0) ? <ul className="list-unstyled"> {detailedData.amenities.map((val) => {return <li>{val}</li>})}</ul> : <p>No amenities listed</p>}            
          </div>
        </div>
        <div class="col-md-6">
          <div class="box">
            <h3>About the other residents</h3>
            {(detailedData.roommateAttributes && detailedData.roommateAttributes.length > 0) ? <ul className="list-unstyled"> {detailedData.roommateAttributes.map((val) => {return <li>{val}</li>})}</ul> : <p>No additional information listed</p>}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="box">
            <h3>Rental information</h3>
            <dl>
              {(detailedData.securityDeposit) ? <><dt>Security deposit</dt><dd>${detailedData.securityDeposit}</dd></> : ''}
              {(detailedData.rent) ? <><dt>Rent</dt><dd>${detailedData.rent}</dd></> : ''}
              {(detailedData.leaseTypeTitle) ? <><dt>Lease type</dt><dd>{detailedData.leaseTypeTitle}</dd></> : ''}
              {(detailedData.leaseEndDate) ? <><dt>Lease end date</dt><dd>{(moment(detailedData.leaseEndDate).format('MM/DD/YYYY') === '01/01/0001') ? 'Flexible' : moment(detailedData.leaseEndDate).format('MM/DD/YYYY')}</dd></> : ''}
              {(detailedData.unitTypeTitle) ? <><dt>Unit type</dt><dd>{detailedData.unitTypeTitle}</dd></> : ''}
            </dl>
          </div>
        </div>
        <div class="col-md-6">
          <div class="box">
            <h3>Utilities included in rent</h3>
            {(detailedData.utilities && detailedData.utilities.length > 0) ? <ul className="list-unstyled"> {detailedData.utilities.map((val) => {return <li>{val}</li>})}</ul> : <p>No utilities listed</p>}            
          </div>
        </div>
        </div>
     </div>
     </div>
</div>

  );
};

export default ListItemDetails;
